<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (about) {
    <div class="text-center">
        @if (halloweenLogo) {
            <img
                class="about-logo"
                [title]="'happyHalloween' | t"
                src="/assets/img/halloween.gif"
                alt="Cerrix-Logo"
            />
        } @else {
            <img class="about-logo" src="/assets/img/logo.svg" alt="Cerrix-Logo" />
        }
        <div>
            <b>{{ about.product }}</b>
        </div>
        <table>
            <tbody>
                <tr>
                    <td colspan="2"><hr /></td>
                </tr>
                <tr>
                    <td>{{ 'versionNumber' | t }}</td>
                    <td>{{ about.version }}</td>
                </tr>
                <tr>
                    <td>{{ 'versionDate' | t }}</td>
                    <td>{{ about.datePublished }} <small>{{ 'timezoneLabel' | t }}</small></td>
                </tr>
                <tr>
                    <td colspan="2"><hr /></td>
                </tr>
            </tbody>
        </table>
    </div>
}
